import { render, staticRenderFns } from "./ks-society.vue?vue&type=template&id=467b5b0e"
var script = {}
import style0 from "./ks-society.vue?vue&type=style&index=0&id=467b5b0e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports